import {isFeatureEnabled} from 'feature-flags';
import {CSSDimension, Box, HStack, getSize, Show, Grid} from 'platform/foundation';

import {EntityResourceIds} from '@dms/api/shared';
import {featureFlags} from '@dms/feature-flags';

import {suffixTestId, TestIdProps} from 'shared/web';

import {SnippetProps} from '../../EntityHeader/components/Snippet';
import {EntityHeaderSnippet} from './EntityHeaderSnippet';

export interface SnippetPanelProps extends TestIdProps {
  snippets?: SnippetProps[];
  areSnippetsLoading?: boolean;
  resourceId?: EntityResourceIds;
}

const MAX_SNIPPET_WIDTH: CSSDimension = `calc(25% - (${getSize(3)}))`; // 3/4 (3 - spaces between 4 snippets) of snippet spacing (4) -> 3
const SNIPPET_WIDTH_MOBILE = 70;
const SINGLE_LINE_MAX_SNIPPETS = 5;
const MULTI_LINE_THRESHOLD = 6;
const MULTI_LINE_MAX_PER_ROW = 4;

export function SnippetPanelV2(props: SnippetPanelProps) {
  if (!props.snippets?.length) {
    return null;
  }

  const isMultiLine = props.snippets.length >= MULTI_LINE_THRESHOLD;
  const columnsCount = isMultiLine ? MULTI_LINE_MAX_PER_ROW : SINGLE_LINE_MAX_SNIPPETS;
  const isVehicleHeaderV3Enabled = isFeatureEnabled(featureFlags.VEHICLE_HEADER_V3);

  return (
    <Box backgroundColor="palettes.white.10.100" data-testid={suffixTestId('snippetPanel', props)}>
      <Show when={isVehicleHeaderV3Enabled && props.snippets.length > SINGLE_LINE_MAX_SNIPPETS}>
        <Grid columns={columnsCount} spacing={4}>
          {props.snippets.map((snippet, index) => (
            <EntityHeaderSnippet
              key={snippet.label}
              data-testid={suffixTestId(`snippetPanel-item-[${index}]`, props)}
              isLoading={props.areSnippetsLoading}
              resourceId={props.resourceId}
              {...snippet}
            />
          ))}
        </Grid>
      </Show>

      <Show when={!isVehicleHeaderV3Enabled || props.snippets.length <= SINGLE_LINE_MAX_SNIPPETS}>
        <Box overflowX="auto" overflowY="hidden">
          <HStack spacing={4} justify="flex-start">
            {props.snippets.map((snippet, index) => (
              <Box
                key={snippet.label}
                flex={[undefined, undefined, 1]}
                minWidth={[SNIPPET_WIDTH_MOBILE, SNIPPET_WIDTH_MOBILE, undefined]}
                maxWidth={[SNIPPET_WIDTH_MOBILE, SNIPPET_WIDTH_MOBILE, MAX_SNIPPET_WIDTH]}
              >
                <EntityHeaderSnippet
                  data-testid={suffixTestId(`snippetPanel-item-[${index}]`, props)}
                  isLoading={props.areSnippetsLoading}
                  resourceId={props.resourceId}
                  {...snippet}
                />
              </Box>
            ))}
          </HStack>
        </Box>
      </Show>
    </Box>
  );
}
